// import { parseRem } from './utils'
const sizeBase = 16

export const TYPOGRAPHY = {
  sizeBase: `${sizeBase}px`,

  /** @property {string} Graphik */
  primary: 'Graphik, sans-serif',
  /** @property {string} Graphik */
  base: 'Graphik, sans-serif',
  /** @property {string} Swile Sans */
  secondary: '"Swile Sans", sans-serif',
  /** @property {string} Swile Sans */
  highlight: '"Swile Sans", sans-serif',

  // Headings
  heading: {
    /** @property {string} 32px Large Title */
    largeTitle: `${(32 / sizeBase) * 1}rem`,
    /** @property {string} 28px h1 */
    h1: `${(28 / sizeBase) * 1}rem`,
    /** @property {string} 24px h2 */
    h2: `${(24 / sizeBase) * 1}rem`,
    /** @property {string} 22px h3 */
    h3: `${(22 / sizeBase) * 1}rem`,
    /** @property {string} 20px h4 */
    h4: `${(20 / sizeBase) * 1}rem`,
    /** @property {string} 18px h5 */
    h5: `${(18 / sizeBase) * 1}rem`,
    /** @property {string} 16px h6 */
    h6: `${(16 / sizeBase) * 1}rem`
  },

  // Body
  weight: {
    /** @property {string} 700 */
    strong: 700,
    /** @property {string} 600 */
    medium: 600,
    /** @property {string} 500 */
    regular: 500,
    /** @property {string} 400 */
    default: '400'
  },

  // Font size
  size: {
    /** @property {string} 10px */
    xxxxs: `${(10 / sizeBase) * 1}rem`,
    /** @property {string} 12px */
    xxxs: `${(12 / sizeBase) * 1}rem`,
    /** @property {string} 14px */
    xxs: `${(14 / sizeBase) * 1}rem`,
    /** @property {string} 16px */
    xs: `${(16 / sizeBase) * 1}rem`,
    /** @property {string} 20px */
    sm: `${(20 / sizeBase) * 1}rem`,
    /** @property {string} 24px */
    md: `${(24 / sizeBase) * 1}rem`,
    /** @property {string} 32px */
    lg: `${(32 / sizeBase) * 1}rem`,
    /** @property {string} 40px */
    xl: `${(40 / sizeBase) * 1}rem`,
    /** @property {string} 48px */
    xxl: `${(48 / sizeBase) * 1}rem`,
    /** @property {string} 56px */
    xxxl: `${(56 / sizeBase) * 1}rem`,
    /** @property {string} 64px */
    display: `${(64 / sizeBase) * 1}rem`
  },

  // Line height
  lineHeight: {
    /** @property {string} 100% */
    tight: '100%',
    /** @property {string} 125% */
    medium: '125%',
    /** @property {string} 150% */
    distant: '150%',
    /** @property {string} 200% */
    superDistant: '200%'
  }
}
